import { render, staticRenderFns } from "./Achievement.vue?vue&type=template&id=4dbecbae&"
import script from "./Achievement.vue?vue&type=script&lang=js&"
export * from "./Achievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports